/**
 * The vendors participating in MDT, shown at ADMIN > Vendors (MYD-658).
 *
 * A static list because nothing adds or edits a vendor yet. Add an entry in any
 * order: the page sorts by name, so this file does not have to stay sorted.
 */

export interface Vendor {
	id: string
	name: string
	/** The card's title: the vendor's logo if it has one, otherwise this text. */
	headline?: string
	logo?: string
	/** Each entry renders on its own line. */
	tagline: string[]
	image: string
	/** The vendor's colour, not ours, so it is data rather than a design token. */
	brandColor: string
	/** The button's wording, which is the vendor's own. */
	demoLabel: string
	demoUrl: string
}

export const VENDORS: Vendor[] = [
	{
		id: 'centercheck',
		name: 'CenterCheck',
		headline: 'Grow your business with Center Check',
		tagline: ['Unparalleled Insights', 'Built on Accurate Data'],
		image: '/images/vendors/centercheck.png',
		brandColor: '#FF6824',
		demoLabel: 'Book a Demo',
		demoUrl: 'https://centercheck.com/book-demo',
	},
	{
		id: 'rolloutiq',
		name: 'RolloutIQ',
		logo: '/images/vendors/rolloutiq-logo.svg',
		tagline: ['Retail and Multi-Site Rollouts'],
		image: '/images/vendors/rolloutiq.png',
		brandColor: '#183CA5',
		demoLabel: 'Request a Demo',
		demoUrl: 'https://www.rolloutiq.com/contact',
	},
]

export const sortVendors = (vendors: Vendor[]): Vendor[] =>
	[...vendors].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))
